export default {
  auth: {
    email: '이메일',
    enter_email: '이메일 입력',
    enter_password: '비밀번호 입력',
    password: '비밀번호',
    saveID: '아이디 저장',
  },
  collabo: {
    characterPopup: {
      action: '캐릭터 등록',
      cancel: '취소',
      content: '콜라보 신청을 위해 최소 1개 이상의 캐릭터를 등록해주세요.',
      title: '등록된 캐릭터가 없습니다.',
    },
    collaboration_introduction: '콜라보 소개',
  },
  collabo_subText: '지금 이 기업들이 콜라보할 IP를 찾고있어요!',
  common: {
    '403BtnLabel': '이전으로 돌아가기',
    '403Desc1': '접근이 제한되었어요',
    '403Desc2': '이 페이지를 열람할 수 있는 권한이 없어요.',
    '403Desc3': '권한 설정이나 URL을 다시 확인해 주세요.',
    '404Desc1': '페이지를 찾을 수 없어요',
    '404Desc2': '입력한 주소가 변경 혹은 삭제됐을 수 있어요.',
    '404Desc3': '입력한 주소를 다시 확인해 주세요.',
    Inquiry: '문의하기',
    activityLabel: '활동명',
    activityLogLabel: '활동 이력 관리',
    addImage: '이미지 추가',
    addLabel: '추가하기',
    agreeAllLabel: '모두 동의합니다.',
    alreadyRegLabel: '이미 회원이신가요?',
    america: '미국',
    applicantsNumber: '신청자 수',
    applyBtnLabel: '신청하기',
    apply_desc1:
      '보유한 캐릭터 중에서 이번 콜라보에 참여할 캐릭터를 선택해 주세요.',
    apply_desc2: '빠짐없이 입력해 주세요! 📝',
    apply_title1: '어떤 캐릭터로 신청할까요?',
    apply_title2: '콜라보 신청을 위한 필수 입력 사항이에요.',
    apply_verified_mark: '인증 마크 신청서 작성',
    askRegCharacter: '캐릭터 등록하기',
    attachFileLabel: '파일을 첨부해 주세요',
    autoSelect: '자동 추천',
    basicInfoLabel: '기본 정보',
    belowCountLabel: '이하',
    benefit: '혜택',
    bgColorLabel: '배경색',
    btnConfirmLabel: '확인',
    categoryCharacter: '어울리는 분야별',
    categoryDescLabel:
      '내 캐릭터와 연관이 있는 카테고리를 선택해 주세요. 카테고리는 중복 선택이 가능합니다.',
    categoryGenre: '장르별 카테고리',
    categoryItem: '제품별 카테고리',
    categoryLabel: '카테고리',
    cautionEmailContent: '이메일을 다시 한번 확인해 주세요.',
    cautionEmailTitle: '가입되지 않은 이메일입니다.',
    cautionLabel: '유의사항',
    cautionPhoneContent: '휴대폰 번호를 다시 한번 확인해 주세요.',
    cautionPhoneTitle: '가입되지 않은 휴대폰 번호입니다.',
    changeLabel: '바꾸기',
    changePwd: '비밀번호 변경',
    charAge: '연령대',
    charAllCategory: '전체 카테고리',
    charCategory: '내 캐릭터와 어울리는 제품 및 서비스',
    charCategory2: '활용 분야',
    charCategoryErrTxt: '최소 1개 이상의 카테고리를 선택해 주세요.',
    charCopyText1: '✔️ 등록된 저작권이 있다면 입력해주세요.',
    charCopyText1_2:
      '캐릭터 저작권, 디자인 저작권 등 등록 기관과 카테고리에 따라 번호 형식이 다를 수 있어요.',
    charCopyText2: '💡 꼭 입력해야 하나요?',
    charCopyText2_2:
      '아니요! 저작권 등록 없이도 캐릭터를 등록할 수 있어요. 다만, 브랜드사와 협업할 때 참고 자료가 될 수 있어요.',
    charCopyright: '저작권 등록번호',
    charCopyrightErr: '유효하지 않은 저작권 번호가 존재합니다.',
    charCopyrightLabel1:
      '캐릭터의 공식 등록 정보와 활동 채널을 입력해주세요. 📣',
    charCopyrightLabel2:
      '캐릭터의 세계관, 브랜드와 협업한 사례, 캐릭터를 활용한 굿즈 디자인 등',
    charCount: '개',
    charDescriptionErrTxt: '캐릭터 소개를 작성해 주세요.',
    charDetailDesc1: '캐릭터를 더 잘 보여줄 수 있는 정보를 추가해보세요. 📖',
    charDetailDesc2:
      '캐릭터의 세계관, 브랜드와 협업한 사례, 캐릭터를 활용한 굿즈 디자인 등',
    charFileSelect: '파일 선택하기',
    charGenre: '캐릭터 장르',
    charGenreErrTxt: '최소 1개 이상의 장르를 선택해 주세요.',
    charHeader1: '기본 정보 입력',
    charHeader2: '썸네일 설정',
    charHeader3: '태그&카테고리 설정',
    charHeader4: '라이브러리',
    charHeader5: '세부 정보',
    charHeader6: '저작권 및 SNS채널',
    charImageErr: '이미지를 업로드 해주세요.',
    charIntroDesc: '캐릭터를 소개해주세요 🙌',
    charIntroDesc2:
      '이름과 한 줄 소개, 국적을 입력하면 캐릭터 등록이 시작됩니다.',
    charIntroErrTxt: '최소 1글자 이상의 캐릭터 이름을 작성해 주세요.',
    charIntroLabel: '한 줄 소개',
    charKeywordLabel1: '연관된 키워드와 활용 분야를 설정해보세요 🔎',
    charKeywordLabel2: '사람들이 내 캐릭터를 더욱 쉽게 찾을 수 있습니다.',
    charLibCard: '카드 추가',
    charLibLabel1: '캐릭터의 다양한 모습을 추가해보세요 📸',
    charLibLabel2:
      'IP를 구성하는 캐릭터가 여러명이라면 각각의 이미지를 추가해도 좋아요.',
    charMainCategory1: 'TV 애니메이션',
    charMainCategory3: '인스타툰',
    charMgmtLabel: '캐릭터 관리',
    charNameErrTxt: '최소 1글자 이상의 캐릭터 이름을 작성해 주세요.',
    charNameLabel: '캐릭터 이름',
    charPlaceholder: 'ex. 부스 버디즈 (Booth Buddies)',
    charRegStep: '선택사항 표시가 없는 정보는 필수 기입 항목입니다.',
    charRegStep1Subtitle1: '캐릭터의 대표 이미지를 만들어주세요 🎨',
    charRegStep1Subtitle2: '배경색과 프레임을 고를 수 있어요.',
    charRegStep1Title: '이미지',
    charRegStep3Title:
      '캐릭터에 대해 자세히 알려주세요. 아래의 가이드 텍스트를 참고하시면 좋아요.',
    charRegStep4Title: '공모전 입상 경험 등을 자랑해 주세요!',
    charRegStep5Desc1: '내 캐릭터와 관련된 소셜 계정을 추가해 주세요.',
    charRegStep5Desc2: '굿즈 마켓을 홍보해도 좋아요!',
    charRegSuccessBtn: '확인하러 가기',
    charRegSuccessLabel1: '캐릭터 비즈니스의 첫 시작을',
    charRegSuccessLabel2: '이너부스에서 함께 합니다.',
    charRegSuccessTxt1: '캐릭터 등록을',
    charRegSuccessTxt2: '축하합니다!',
    charSec4Desc1: '러그 50개부터 제작 가능!',
    charSec4Desc2: '우리는 이렇게 대답하지 않아요',
    charSec4Desc3: '“가격 별도 문의, 시안 확인 후 견적 가능”',
    charSec4Subtitle1: '이너부스에 캐릭터를 등록하고,',
    charSec4Subtitle2: '최대 10% 할인 혜택을 받아보세요',
    charSec4Subtitle3: '가장 트렌디한 굿즈 정보를',
    charSec4Subtitle4: '제일 먼저 받아보세요',
    charSec4Title1: '눈높은 크리에이터,',
    charSec4Title2: '잘나가는 기업이 만드는',
    charSec4Title3: '캐릭터 굿즈',
    charSec4Title4: '클릭 몇 번으로',
    charSec4Title5: '완성도 높은',
    charSec4Title6: '브랜드 굿즈를 만들어요!',
    charSelectBg: '배경색 고르기',
    charSex: '성별',
    charSnsErr: '유효하지 않은 SNS 주소가 존재합니다.',
    charSnsText1: '🚀 공식 인증 크리에이터가 되어보세요!',
    charSnsText1_2:
      '인증마크가 있으면 브랜드사가 검증된 IP를 쉽게 확인할 수 있어요.',
    charSnsText1_3:
      'IP를 효과적으로 홍보하고 라이선싱/콜라보 제안이 증가할 수 있습니다.',
    charSnsText2: '💌 인증 방법',
    charSnsText2_2:
      '신청서를 작성후 제출해주시면, 심사 후 영업일 3-5일 이내에 메일 안내 드립니다.',
    charSnsText3: '📝 신청 시 필요한 정보',
    charSnsText3_1: '1. 브랜드 기본 정보',
    charSnsText3_1_1:
      '해당 계정이 본인 소유임을 인증할 수 있는 이미지여야 합니다.',
    charSnsText3_1_2:
      '해당 계정이 캐릭터와 관련된 공식적이고 활발한 활동 이력이 있어야 합니다.',
    charSnsText3_2: '2. IP의 공식 계정 인증',
    charSnsText3_2_1:
      '크리에이터 : IP가 본인 소유임을 인증할 수 있는 증빙 제출 필요',
    charSnsText3_2_2:
      '에이전시 : 직접 관리하는 IP임을 인증할 수 있는 증빙 제출 필요',
    charSnsText3_3: '3. 메인으로 운영 중인 SNS 채널 주소',
    charSnsText3_4: '4. 아래 지표 중 해당되는 정보 (선택)',
    charSnsText3_4_1: '유통/매출 현황',
    charSnsText3_4_2: '이모티콘 승인 개수',
    charSnsText3_4_3: '주요 페어 참가 이력',
    charSnsText3_4_4: '브랜드 협업 사례',
    charSuccess1: '캐릭터 비지니스의 첫 시작을',
    charSuccess2: '이너부스에서 함께 합니다.',
    charTagDesc:
      '사람들이 내 캐릭터를 쉽게 찾을 수 있도록 연관된 키워드를 추가해 주세요. ex) 이모티콘, 문구용품, 병아리, 노란색, 발랄한',
    charTagErrTxt: '최소 2개 이상의 태그를 설정해 주세요.',
    charTagLabel: '태그 입력',
    charTarget: '주요 타겟',
    charTitle1: '어떤 캐릭터를',
    charTitle2: '찾으시나요?',
    charUpdateText1: '지금 확인해 볼까요?',
    charUpdateText2: '확인을 누르면 캐릭터 정보 페이지로 이동합니다.',
    charUseInquiryLabel: '캐릭터 이용 문의',
    charViewCategory: '카테고리 더보기',
    characterImgDesc: '여기에 이미지 끌어다 놓기',
    characterIpManagerLabel: '캐릭터 IP 권리자',
    characterLabel: '캐릭터',
    characterSearchButtonLabel: '캐릭터 검색하기',
    character_banner1: '캐릭터, 1인 창작자,',
    character_banner2: '에이전시의',
    character_banner3: '모든 정보를',
    character_banner4: '찾아보세요.',
    china: '중국',
    chooseTypeLabel: '유형선택',
    clickLabel: '클릭',
    'collabo-info-confirm': '콜라보 정보 확인하기',
    collaboAdText: '굿즈 판매하는 캐릭터 작가라면? 꼭 알아야할 세금 지식!',
    collaboBrand: '브랜드 고객이신가요?',
    collaboDeadlineLabel: '모집 마감',
    collaboDoneEditSubtitle: '수정된 콜라보는',
    collaboDoneEditTitle: '수정되었습니다!',
    collaboDoneSubtitle1: '오픈된 콜라보는',
    collaboDoneSubtitle2: '마이부스에서 확인할 수 있어요.',
    collaboDoneTitle1: '콜라보가',
    collaboDoneTitle2: '오픈되었습니다!',
    collaboFileDesc: '여기에 파일 끌어다 놓기 (5mb 이하)',
    collaboLabel: '콜라보',
    collaboNavLabel1: '브랜드 소개',
    collaboNavLabel2: '함께하고 싶은 희망 IP',
    collaboNavLabel3: '유의사항 확인하기',
    collaboNavLabel4: '콜라보 문의',
    collaboNavLabel5: '콜라보 꿀팁',
    collaboPopular: '지금 뜨고있어요!',
    collaboRegist: '콜라보 등록하기',
    collaboStep1Field1: '콜라보 제목',
    collaboStep1Field2: '콜라보 스케줄',
    collaboStep1Field2Placeholder1: '모집 기간을 설정해 주세요.',
    collaboStep1Field2Placeholder2: '결과 발표일을 설정해 주세요.',
    collaboStep1Field2Placeholder3: '결과 이메일 발송일을 설정해 주세요.',
    collaboStep1Field3: '모집 대상',
    collaboStep1Field4: '예상 예산',
    collaboStep1Field4Desc: '대략적인 예산을 적어주세요.',
    collaboStep1Subtitle1: '콜라보 오픈에 필요한 필수 정보를 입력해 주세요.',
    collaboStep1Subtitle2: '선택사항 표시가 없는 정보는 필수 기입 항목입니다.',
    collaboStep2Subtitle1: '콜라보에 대해 조금 더 자세히 알려주세요.',
    collaboStep2Subtitle2: '텍스트 사이에 이미지를 넣어주시면 더욱 좋아요.',
    collaboStep3Subtitle1: '콜라보 진행 시 얻을 수 있는 혜택을 적어주세요.',
    collaboStep4Subtitle1: '참여 및 선정 시 유의사항을 적어주세요',
    collaboStep5Field1: '필수입력 항목',
    collaboStep5Field2: '선택입력 항목',
    collaboStep5Field3: '신청완료 문구',
    collaboStep5Field3Placeholder: '미작성 시 기본 문구가 노출됩니다.',
    collaboStep5FieldAdd: '항목 추가하기',
    collaboStep5FieldEtc: '기타 입력항목',
    collaboStep5FieldFile: '파일 첨부',
    collaboStep5FieldFilePlaceholder: '미작성 시 기본 문구가 노출됩니다.',
    collaboStep5FieldInflux: '유입경로',
    collaboStep5FieldOption: '옵션 선택',
    collaboStep5FieldUpload: '양식 파일 업로드',
    collaboStep5Subtitle1: '신청 시 필요한 정보를 설정하세요.',
    collaboStep5Subtitle2:
      '크리에이터가 제출해야 할 내용을 직접 설정할 수 있어요.',
    collaboTeam: '이너부스 콜라보팀',
    collabo_count: '개',
    collabo_open_apply: '콜라보 오픈 신청',
    collabo_tag: '관련 태그',
    companyInfo: '기업 정보',
    companyNameLabel: '회사명',
    completeLabel: '완료',
    confirmFormatErr: '비밀번호가 일치하지 않아요.',
    confirmPwdLabel: '비밀번호 확인',
    connectLabel: '연결',
    contactLabel: '전화번호',
    coporateLabel: '법인',
    copyUrlLabel: 'URL이 복사되었습니다.',
    copyrightNumberLabel: '저작권 등록 번호',
    countCharacter: '개 캐릭터',
    creatorLabel: '크리에이터',
    currentPassword: '현재 비밀번호',
    currentPasswordFormatErr: '현재 비밀번호를 입력해주세요.',
    deleteLabel: '삭제하기',
    demoButtonLabel: '베타 버전 체험해보기',
    detailInfoLabel: '세부 정보',
    editLabel: '수정하기',
    emailFormatErr: '올바른 이메일 형식을 사용해 주세요.',
    emailLabel: '이메일',
    emoticon: '이모티콘',
    ended_collabo: '마감한 콜라보',
    enter_required_information: '필수 정보 입력',
    errDescription:
      '알수없는 오류가 발생했습니다. 이 문제가 지속될 경우 채널톡에 문의해주세요.',
    errText: '알수없는 오류가 발생했습니다.',
    errorPassword: '비밀번호를 다시 확인해 주세요.',
    etcLabel: '기타',
    eventDate: '모집 기간',
    eventLabel: '이벤트',
    eventNavLabel1: '이벤트 정보 확인하기',
    eventNavLabel2: '혜택 확인하기',
    eventNavLabel3: '유의사항 확인하기',
    eventNavLabel4: '이벤트 신청하기',
    eventNavLabel5: '이벤트 결과 보기',
    eventNavNotice: '시작하기에 앞서',
    eventRegist: '이벤트 신청하기',
    eventResult: '예상 선정일',
    eventTarget: '모집 대상',
    facebookLabel: '페이스북',
    factoryLabel: '유통/제조사',
    field_file: '파일 업로드',
    field_select_multi: '다중 선택',
    field_select_one: '단일 선택',
    field_sns: 'SNS 주소',
    field_tel: '전화번호 입력',
    field_text: '텍스트 입력',
    fileSizeLimitLabel: '파일 최대 크기',
    fileTypeLabel: '지원하는 파일 형식',
    fillId: 'ID를 입력해주세요.',
    filterAll: '전체',
    filterEnd: '마감',
    filterIng: '진행중',
    filterLabel: '필터',
    findIdLabel: '아이디 찾기',
    findIdPopupDesc:
      '가입 시 입력하신 휴대폰 번호로 이메일 아이디를 전송했어요. 문자 메시지함을 확인해 주세요.',
    findIdPopupTitle: '아이디 정보를 전송했습니다.',
    findIdPwdLabel: '아이디/비밀번호 찾기',
    findPwdBtnLabel: '비밀번호 재설정 메일 보내기',
    findPwdLabel: '비밀번호 찾기',
    findPwdPopupDesc:
      '가입하신 이메일 아이디로 비밀번호 재설정 메일을 발송했어요. 메일에 첨부된 버튼을 클릭하여 비밀번호를 변경해 주세요.',
    findPwdPopupTitle: '비밀번호 재설정 메일을 발송했습니다.',
    followerLabel: '팔로워',
    formLabel: '신청양식',
    genreCharacter: '장르별 캐릭터',
    gmsLabel: '굿즈매니저',
    goBack: '뒤로가기',
    goHome: '홈으로 돌아가기',
    goNextLabel: '다음',
    goTo: '바로가기',
    goods_management: '굿즈 관리',
    goods_production: '굿즈 제작',
    guideTitle1: '새소식',
    guideTitle2: '이너부스가 처음이세요?',
    header_search: '탐색',
    header_search_partner: '파트너 찾기',
    highlightCollabo: '하이라이트 콜라보',
    highlightCollaboLabel1: '기업 고객이신가요?',
    highlightCollaboLabel2: '하이라이트 콜라보 등록하기',
    image_size1: '용량이 큰 파일을 등록하는 경우',
    image_size2: '다소 시간이 소요될 수 있어요.',
    imgShapeLabel: '프레임 고르기',
    inabooth: '주식회사 이너부스',
    'inabooth-desc':
      '이너부스는 캐릭터를 중심으로 창작자, 사업자, 소비자들이 만나는 공간이기도 합니다. 전세계 모든 캐릭터가 모이는 곳, 이너부스에서 여러분의 캐릭터를 만나보세요.',
    inafactoryLabel: '굿즈제작',
    inbCodeDesc: '이너부스 캐릭터코드는 자동으로 부여됩니다.',
    inbCodeTitle: '이너부스 캐릭터코드',
    infoTypeLabel: '정보입력',
    'inquiry-word': '문의',
    instaLabel: '인스타그램',
    insta_toon: '인스타툰',
    introLabel: '소개',
    ipInfoLabel: 'IP 정보',
    ipNoInfoLabel: '저작권 정보',
    ipRegNoDesc:
      '저작권 등록이 완료된 캐릭터의 경우 저작권 등록번호를 적어주세요.',
    ipRegNoLabel: '저작권 등록번호',
    ipcare: '이너부스 IP케어',
    japan: '일본',
    korea: '한국',
    libraryDescLabel:
      'IP를 구성하는 캐릭터가 여러명이라면 각각의 이미지를 추가해 주세요. 캐릭터가 하나라면 다양한 장면이나 아트웍을 넣어 갤러리처럼 활용해도 좋아요.',
    libraryLabel: '라이브러리 (선택)',
    licensingCreatorDesc1: '크리에이터를 위한',
    licensingCreatorDesc2: '굿즈관리 솔루션',
    licensingCreatorDesc3: '팝업 스토어, 쇼핑몰, 페어, 온라인 입점몰에 출품한',
    licensingCreatorDesc4:
      '굿즈들을 유통 파트너사와 함께 소통하며 관리해보세요',
    licensingDesc1: '당신은 어떤 포지션인가요?',
    licensingDesc2: '지금 바로 꼭 맞는 정보를 확인하세요!',
    licensingFactoryDesc1: '라이선싱 관리 솔루션',
    licensingFactoryDesc2:
      'IP 상품 소싱부터 유통, 복잡한 계약도 이제는 걱정마세요.',
    licensingFactoryDesc3: '이너부스에서 쉽게 도전해보세요',
    licensingLabel: '라이선싱',
    licensingPlannerDesc1:
      '우리회사 신규 프로젝트/제품에 콜라보 할 캐릭터 IP를 찾아보세요.',
    licensingPlannerDesc2: '라이선싱 협의가 어렵다면 이너부스가 도와드려요.',
    licensingSolution: '라이선싱 솔루션',
    licensingSubtitle1: '이너부스는 캐릭터를 중심으로',
    licensingSubtitle2:
      '크리에이터, 사업자, 소비자가 만나는 IP 비즈니스 공간입니다.',
    licensingSubtitle3: '전세계 모든 캐릭터가 모이는 곳, 이너부스에서',
    licensingSubtitle4: '여러분의 캐릭터를 만나보세요.',
    licensingText1: '당신은',
    licensingText2: '어떤 포지션인가요?',
    licensingTitle1: '24시간 열리는',
    licensingTitle2: '캐릭터 라이선싱 페어',
    mainAskCreator: '에이전시, 크리에이터인가요? ',
    mainCategoryLabel1: '인기',
    mainCategoryLabel2: '문구 / 팬시 / 완구',
    mainCharCount: '캐릭터가 기다리는 중',
    mainCharcterSearchHint: '동물 캐릭터',
    mainDescription: '1,100여개 기업이 협업 캐릭터를 찾고 있어요.',
    mainImgLabel: '대표 이미지',
    mainSec2Title1: '캐릭터 라이선싱이 ',
    mainSec2Title2: '쉬워지다.',
    mainSec5BtnLabel: '5초만에 캐릭터 등록하기',
    mainSec5Desc: '업로드 형식',
    mainSec5Title1: '내 캐릭터 등록하고',
    mainSec5Title2: '라이선스 비즈니스',
    mainSec5Title3: '시작하기!',
    mainSec7Desc1: '캐릭터 업계에서 일어나는 흥미로운 이슈와',
    mainSec7Desc2: '이너부스에 등록된 최신 캐릭터 정보를 보내드립니다.',
    mainSec7Title1: '지금 회원가입하고',
    mainSec7Title2: '뉴스레터를 받으세요',
    mainTitle1: 'IP 라이선싱 & 콜라보 파트너십을',
    mainTitle2: '한 곳에서 발견하세요',
    main_sub_description:
      '캐릭터, 1인 창작자, 에이전시의 모든 정보를 검색하세요',
    make_form: '양식 만들기',
    maxSizeLabel: '최적 사이즈',
    meritLabel: '혜택',
    minResolutionLabel: '최소 해상도',
    minSize: '최소 사이즈',
    minWordLabel: '최소 1글자 이상을 작성해 주세요.',
    myBoothLabel: '마이부스',
    my_profile: '내 프로필',
    nameFormatErr: '은 최대 20자까지 허용됩니다.',
    nameFormatErr2: '을 적어주세요.',
    newPassword: '새 비밀번호',
    new_character: '새 캐릭터 등록',
    newlyRegCharacter: '새로 업데이트된 캐릭터',
    nextPageLabel: '다음 페이지',
    nicknameLabel: '닉네임',
    noCollaboEventLabel: '아직 참여한 콜라보 및 이벤트가 없어요.',
    noCollaboLabel: '아직 참여한 콜라보가 없어요.',
    noLikeCollaboLabel: '아직 관심 콜라보가 없어요.',
    notClientBtnLabel: '클라이언트로 회원가입',
    notClientDesc1: '앗, 콜라보를 등록할 수 없어요.',
    notClientDesc2: '고객님은 크리에이터 회원이에요.',
    notClientDesc3: '콜라보는 클라이언트 회원만 등록할 수 있어요.',
    notCreatorBtnLabel: '크리에이터로 회원가입',
    notCreatorDesc1: '앗, 캐릭터를 등록할 수 없어요.',
    notCreatorDesc2: '고객님은 클라이언트 회원이에요.',
    notCreatorDesc3: '캐릭터는 크리에이터 회원만 등록할 수 있어요.',
    notRegYetLabel: '아직 회원이 아니신가요?',
    onlyNumber: '숫자만 입력 가능해요.',
    openButtonLabel: '오픈하기',
    openCollaboLabel: '콜라보 오픈',
    optionalLabel: '선택',
    originalCountry: '원작 국가',
    passwordFormatErr: '영문, 숫자, 특수문자를 포함하여 설정해 주세요.',
    passwordLabel: '비밀번호',
    personLabel: '명',
    personalInfoAgreeLink: '개인정보 처리방침',
    phoneNumberDescLabel:
      '회원가입 시 등록한 번호로 이메일 아이디를 보내드립니다.',
    phoneNumberLabel: '휴대폰 번호',
    plannerLabel: '상품 기획자',
    popularKeywords: '인기 키워드',
    prevLabel: '이전',
    prevPageLabel: '이전 페이지',
    previewLabel: '미리보기',
    profileEdit: '프로필 편집',
    profilePicInstru1: '2MB 이하의 이미지 파일',
    profilePicInstru2: '권장 사이즈 : 500x500px',
    profilePicLabel: '프로필 이미지',
    project: '프로젝트',
    recruitLabel: '채용',
    recruitStatus: '채용중',
    regCharacterLabel: '캐릭터 등록',
    regDateLabel: '등록일',
    regEmail: '가입 이메일',
    regist_form: '신청 양식',
    regist_project: '프로젝트 등록하기',
    requiredLabel: '필수',
    required_error: '이 항목은 필수입니다.',
    resultWaitingLabel: '결과발표 대기중',
    rising_character: '떠오르는 라이징 캐릭터',
    saveIdLabel: '아이디 저장',
    searchCharacterLabel: '개의 캐릭터가 검색되었어요',
    searchLabel: '검색',
    selectChannel: '채널 선택',
    selectImage: '이미지 선택',
    select_character: '캐릭터를 선택하세요.',
    select_date: '날짜를 선택해 주세요.',
    serviceAgreeLink: '서비스 이용약관',
    signInLabel: '로그인',
    signInWithGoogleLabel: 'Google로 로그인',
    signOutLabel: '로그아웃',
    signUpAgree1: '본인이 만 14세 이상입니다.',
    signUpAgree21: '이너부스의',
    signUpAgree22: '이용약관',
    signUpAgree23: '에 동의합니다.',
    signUpAgree31: '개인정보처리방침',
    signUpAgree32: '을 모두 확인하였으며 이에 동의합니다.',
    signUpAgree4: '이벤트 혜택, 소식알림 수신에 동의합니다.',
    signUpEmailLabel: '이메일로 회원가입',
    signUpLabel: '회원가입',
    similarCharacterLabel: '비슷한 느낌의 캐릭터',
    smartStoreLabel: '스마트스토어',
    snsInfoLabel: '공식 SNS 채널 ',
    socialSignInLabel: 'SNS 계정 간편 로그인',
    solution: '솔루션',
    solutionLabel: '솔루션',
    sortCriteria: '정렬기준',
    sortNewLabel: '최신순',
    sortRecommendLabel: '추천순',
    stationery__fancy_toys: '문구 / 팬시 / 완구',
    statusLabel: '상태',
    suggest_collabo: '콜라보 신청하기',
    tagCount: '개',
    tempSave: '임시저장',
    thumbnailImgDesc: '가장 먼저 노출이 되는 썸네일 이미지입니다.',
    thumbnailImgDesc1: '가장 먼저 노출이 되는 썸네일 이미지입니다.',
    thumbnailImgDesc2:
      '이미지 프레임과 배경색 설정을 통해 다양한 연출이 가능합니다.',
    thumbnailImgLabel: '썸네일 이미지',
    title: '제목',
    toOpenCollabo: '오픈한 콜라보',
    trendCollabo: '지금 뜨고 있는 콜라보',
    trendLabel: '트렌드',
    twitterLabel: '트위터',
    updateComplete: '수정이 완료되었습니다!',
    updateLabel: '업데이트',
    updateNoteLabel: '업데이트 노트',
    updatePassword: '비밀번호가 변경되었습니다.',
    uploading: '업로드 중...',
    userType1Desc: '캐릭터 창작자, 스튜디오, 에이전시',
    userType1Title: '캐릭터를 보유하고 있어요',
    userType2Desc: '상품/서비스 기획자, 마케팅 담당자',
    userType2Title: '캐릭터를 이용하고 싶어요',
    verified_character: '인증된 캐릭터',
    viewBlogBtnLabel: '보러가기',
    viewCollection: '콜렉션 보기',
    viewMoreLabel: '더보기',
    view_all_style: '전체 스타일 보기',
    wonLabel: '원',
    writeURLErrTxt: 'url을 입력해 주세요.',
    writeUrlLabel: 'url을 입력',
    youtubeLabel: '유튜브',
  },
  welcome: '환영합니다',
} as const
